module.exports = __webpack_public_path__ + "img/5-preview.8b07597f.jpg";